import { render, staticRenderFns } from "./MarketInvoicesTableProductsCount.vue?vue&type=template&id=2b3afd84&"
import script from "./MarketInvoicesTableProductsCount.vue?vue&type=script&lang=js&"
export * from "./MarketInvoicesTableProductsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports